import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=9cc8c106&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=9cc8c106&prod&lang=less&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&id=9cc8c106&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc8c106",
  null
  
)

export default component.exports